"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
require("./DataTable.css");
var Row_1 = __importDefault(require("./Row"));
var Cell_1 = __importDefault(require("./Cell"));
var Header_1 = __importDefault(require("./Header"));
var Footer_1 = __importDefault(require("./Footer"));
var HeaderBulkAction_1 = __importDefault(require("./HeaderBulkAction"));
var DataContext_1 = require("../DataContext");
function DataTable(_a) {
    var children = _a.children, _b = _a.skeleton, skeleton = _b === void 0 ? false : _b, bulkAction = _a.bulkAction, selectedRowsId = _a.selectedRowsId, onSelectRow = _a.onSelectRow, _c = _a.background, background = _c === void 0 ? "none" : _c;
    var className = (0, classnames_1.default)("nimbus--data-table", "nimbus--data-table--background-".concat(background));
    return (React.createElement(DataContext_1.DataContextProvider, { skeleton: skeleton, bulkAction: bulkAction, selectedRowsId: selectedRowsId, onSelectRow: onSelectRow },
        React.createElement("div", { className: className },
            bulkAction && React.createElement(HeaderBulkAction_1.default, { bulkAction: bulkAction }),
            children)));
}
DataTable.Header = Header_1.default;
DataTable.Row = Row_1.default;
DataTable.Cell = Cell_1.default;
DataTable.Footer = Footer_1.default;
exports.default = DataTable;
//# sourceMappingURL=DataTable.js.map